'use strict';

module.exports = {
    languagepacks: function (paths, done) {
        var messages = JSON.parse(document.querySelector('.application-root').getAttribute('data-messages'));
        var result = {};

        if (paths) {
            paths.forEach(function (path) {
                Object.assign(result, messages[path]);
            });
        }

        done(result);
    }
};



/** WEBPACK FOOTER **
 ** ./public/js/utils/TemplateLoader.js
 **/